/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Delete } from '../fn/error-log/delete';
import { Delete$Params } from '../fn/error-log/delete';
import { ErrorLogModel } from '../models/error-log-model';
import { ErrorLogViewModelPrimeDatatableResults } from '../models/error-log-view-model-prime-datatable-results';
import { Get } from '../fn/error-log/get';
import { Get$Params } from '../fn/error-log/get';
import { GetBugSupportTickets } from '../fn/error-log/get-bug-support-tickets';
import { GetBugSupportTickets$Params } from '../fn/error-log/get-bug-support-tickets';
import { GetGitHubIssues } from '../fn/error-log/get-git-hub-issues';
import { GetGitHubIssues$Params } from '../fn/error-log/get-git-hub-issues';
import { GithubIssueViewModel } from '../models/github-issue-view-model';
import { LinkGitHubIssue } from '../fn/error-log/link-git-hub-issue';
import { LinkGitHubIssue$Params } from '../fn/error-log/link-git-hub-issue';
import { LinkSupportTicket } from '../fn/error-log/link-support-ticket';
import { LinkSupportTicket$Params } from '../fn/error-log/link-support-ticket';
import { List } from '../fn/error-log/list';
import { List$Params } from '../fn/error-log/list';
import { SupportTicketViewModel } from '../models/support-ticket-view-model';

@Injectable({ providedIn: 'root' })
export class ErrorLogApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiErrorLogListPost()` */
  static readonly ApiErrorLogListPostPath = '/api/ErrorLog/List';

  /**
   * List Exception Log Entries.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<ErrorLogViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * List Exception Log Entries.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<ErrorLogViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<ErrorLogViewModelPrimeDatatableResults>): ErrorLogViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiErrorLogGetPost()` */
  static readonly ApiErrorLogGetPostPath = '/api/ErrorLog/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<ErrorLogModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<ErrorLogModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<ErrorLogModel>): ErrorLogModel => r.body)
    );
  }

  /** Path part for operation `apiErrorLogDeletePost()` */
  static readonly ApiErrorLogDeletePostPath = '/api/ErrorLog/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Delete()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete$Response(params?: Delete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Delete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Delete$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete(params?: Delete$Params, context?: HttpContext): Observable<void> {
    return this.Delete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiErrorLogLinkGitHubIssuePost()` */
  static readonly ApiErrorLogLinkGitHubIssuePostPath = '/api/ErrorLog/LinkGitHubIssue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `LinkGitHubIssue()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  LinkGitHubIssue$Response(params?: LinkGitHubIssue$Params, context?: HttpContext): Observable<StrictHttpResponse<GithubIssueViewModel>> {
    return LinkGitHubIssue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `LinkGitHubIssue$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  LinkGitHubIssue(params?: LinkGitHubIssue$Params, context?: HttpContext): Observable<GithubIssueViewModel> {
    return this.LinkGitHubIssue$Response(params, context).pipe(
      map((r: StrictHttpResponse<GithubIssueViewModel>): GithubIssueViewModel => r.body)
    );
  }

  /** Path part for operation `apiErrorLogGetGitHubIssuesGet()` */
  static readonly ApiErrorLogGetGitHubIssuesGetPath = '/api/ErrorLog/GetGitHubIssues';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetGitHubIssues()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetGitHubIssues$Response(params?: GetGitHubIssues$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GithubIssueViewModel>>> {
    return GetGitHubIssues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetGitHubIssues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetGitHubIssues(params?: GetGitHubIssues$Params, context?: HttpContext): Observable<Array<GithubIssueViewModel>> {
    return this.GetGitHubIssues$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GithubIssueViewModel>>): Array<GithubIssueViewModel> => r.body)
    );
  }

  /** Path part for operation `apiErrorLogGetBugSupportTicketsGet()` */
  static readonly ApiErrorLogGetBugSupportTicketsGetPath = '/api/ErrorLog/GetBugSupportTickets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetBugSupportTickets()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBugSupportTickets$Response(params?: GetBugSupportTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupportTicketViewModel>>> {
    return GetBugSupportTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetBugSupportTickets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBugSupportTickets(params?: GetBugSupportTickets$Params, context?: HttpContext): Observable<Array<SupportTicketViewModel>> {
    return this.GetBugSupportTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SupportTicketViewModel>>): Array<SupportTicketViewModel> => r.body)
    );
  }

  /** Path part for operation `apiErrorLogLinkSupportTicketPost()` */
  static readonly ApiErrorLogLinkSupportTicketPostPath = '/api/ErrorLog/LinkSupportTicket';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `LinkSupportTicket()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  LinkSupportTicket$Response(params?: LinkSupportTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return LinkSupportTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `LinkSupportTicket$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  LinkSupportTicket(params?: LinkSupportTicket$Params, context?: HttpContext): Observable<void> {
    return this.LinkSupportTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
